<template>
	<div class="animated fadeIn purchaseorders--purchaseorders-list">
		<fixed-header title="Purchase Orders" :records="pageInfo.totalItems" hideBackBtn>
			<add-purchase-order v-if="checkClaim(CAN_ADD_POS)" />
		</fixed-header>

		<div class="card">
			<div class="card-body">
				<div class="d-flex justify-content-start align-items-end mb-2">
					<b-form-group label="Status" class="mr-2">
						<b-form-select v-model="filtersObj.statusId" :disabled="isReceive" @change="onSearch">
							<option :value="null">All</option>
							<option v-for="option in sortSelect(purchaseOrdersStatusOptions)" :key="option.name" :value="option.id">
								{{option.name}}</option>
						</b-form-select>
					</b-form-group>
					<b-form-group label="Purchase Order Number" class="mr-2">
						<b-form-input v-model="filtersObj.poNumber" @input="onSearch"  size="sm" />
					</b-form-group>
					<b-form-group label="Company" class="mr-2">
						<b-form-input v-model="filtersObj.companyName" @input="onSearch" size="sm" />
					</b-form-group>
					<b-form-group label="Needs auth" class="mr-2" style="margin-bottom: 5px;">
						<b-form-checkbox v-model="filtersObj.needsAuthorization" :indeterminate.sync="filtersObj.needsAuthorization" @input="onSearch" />
					</b-form-group>
					<b-form-group label="Sales Rep" class="mr-2" v-if="checkClaim(CAN_VIEW_ALL_POS)">
						<b-form-select v-model="filtersObj.salesPersonUserId" @change="onSearch">
							<option :value="null">All</option>
							<option
								v-for="(selectRep, indexRep) in sortSelect(salesReps)"
								:key="indexRep"
								:value="selectRep.id"
							>{{ selectRep.name }}</option>
						</b-form-select>
					</b-form-group>
          <date-range-picker :dateFrom="filtersObj.dateFrom" :dateTo="filtersObj.dateTo" @handleSearch="onSearch"></date-range-picker>
					<b-button class="mr-2" size="sm" @click="clearFilter">Clear filters</b-button>
				</div>
				<grid-component
					isResizable
					isReorderable
					isSortable
					:canEdit="checkClaim(CAN_EDIT_POS)"
					:canDelete="checkClaim(CAN_DELETE_POS)"
					:gridId="gridId"
					:pageable="pageable"
					:skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
					:take="pageInfo.pageSize"
					:itemData="itemData"
					:pageSizes="pageInfo.pageSize"
					:totalItems="pageInfo.totalItems"
					:fields="fields"
					:sortBy="pageInfo.sortBy"
					:sortOrder="pageInfo.sortOrder"
					:sortMethod="sortGrid"
					:onEdit="onEdit"
					:onDelete="onDelete"
					:handleRowClick="onRowClick"
					:styleCustom="'height: 335px'"
					@getData="onGetData"
         			:isTblLoader="tblLoader"
					/>
			</div>
		</div>
		<b-card>
      <div class="d-flex">
        <div v-if="checkClaim(CAN_RECIEVE_POS)" class="mr-2">
        <a class="mr-2">To receive an item, select the row and click</a>
        <b-button size="sm" variant="primary" @click="onReceiveItem" :disabled="isDisableReceiveItem" >Receive Item</b-button>
        </div>
        <b-button v-if="checkClaim(CAN_ADD_WORK_ORDER)" @click="$bvModal.show('add-service-order-modal')" size="sm" variant="primary" :disabled="!purchaseOrderLine.id">
          Create Work Order
        </b-button>
        <add-service-order :poLineDetail="purchaseOrderLine" v-if="checkClaim(CAN_ADD_WORK_ORDER)" />
      </div>
			<b-tabs>
				<b-tab active>
          <template v-slot:title>
            Purchase Order Items &nbsp;<b-badge variant="primary">{{ purchaseOrderLines.length }}</b-badge>
          </template>
					<purchase-order-lines
						:purchaseOrderId="selectedRowItemId"
						@showEdit="onShowEdit"
						@selectedPurchaseOrderLine="purchaseOrderLineSelected" />
				</b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_ALL_WORK_ORDERS)">
          <template v-slot:title>
            Work Orders &nbsp;<b-badge variant="primary">{{ serviceordersList.length }}</b-badge>
          </template>
          <service-orders :purchaseOrderId="selectedRowItemId" :forPage="'purchaseOrderList'" :filterPageName="'PoListSoTab'" />
        </b-tab>
			</b-tabs>
		</b-card>

		<div id="add-part-popup" class="d-inline pull-left">
			<b-modal id="add-part-popup" ref="add-part-popup" size="xl" ok-title="Save" 
				scrollable>
				<template slot="modal-header">
				<h5 class="modal-title">Edit Line Detail</h5>
				</template>

				<line-details
					ref="editLineDetails"
					onPurchase
					:lineObj="purchaseOrderLine"
					@partChange="onPartChange"
					@lineChange="onLineChange"
					@headerChange="onHeaderChange"
					@line-validation="isLineInvalid = $event"
				/>

				<template slot="modal-footer">
          <b-button @click="$bvModal.hide('add-part-popup')">Cancel</b-button>
          <b-button v-if="checkClaim(CAN_EDIT_POS)" class="mr-2" variant="primary" @click="savePartForm" :disabled="isSavingLine">
            <i v-if="isSavingLine" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>          
        </template>
			</b-modal>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
	import { debounce, unionBy } from 'lodash';
	import FixedHeader from '@/shared/components/FixedHeader/indexNew';
	import PurchaseOrderLines from '@/pages/PurchaseOrders/components/PurchaseOrderLines';
	import { GRID_PAGE_SIZES, GRID_ID, PURCHASE_ORDER_STATUS, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
	import GridSettings from '@/shared/components/GridSettings';
	import RequirementDetails from '@/shared/components/RequirementDetails/index';
	import LineDetails from '@/shared/components/LineDetails/index';
	import GridComponent from '@/shared/components/GridComponent';
	import AddPurchaseOrder from './components/add';
  import AddServiceOrder from '@/pages/PurchaseOrders/components/edit/components/AddServiceOrder';
	import gridFields from './fields';
  import ServiceOrders from '@/shared/components/ServiceOrders';
	import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';

	export default {
		components: {
			FixedHeader,
			PurchaseOrderLines,
			GridSettings,
			DateRangePicker,
			AddPurchaseOrder,
			GridComponent,
			RequirementDetails,
			LineDetails,
      AddServiceOrder,
      ServiceOrders
		},
		props: {
			isReceive: {
				type: Boolean,
				default: false,
			},
		},
		metaInfo: () => ({
			title: 'Purchaseorders',
		}),
		data() {
			return {
				fields: gridFields,
				gridId: GRID_ID.PURCHASE_ORDERS,
				pageable: {
					pageSizes: GRID_PAGE_SIZES,
				},
				selectedRowItemId: 0,
				// purchaseOrdersStatusOptions:[
				// 	{ id: 153, name: 'Cancelled' },
				// 	{ id: 154, name: 'Closed' },
				// 	{ id: 155, name: 'Open' },
				// 	{ id: 156, name: 'Partially Received' },
				// 	{ id: 157, name: 'Received' },
				// 	{ id: 222, name: 'Pending' },
				// ],
        purchaseOrdersStatusOptions: PURCHASE_ORDER_STATUS,
				purchaseOrderLine: {},
				purchaseOrderLinePartForm: {},
				mergedObj: {},
				filterPageName: 'poListPage',
				isLineInvalid: false,
				isSavingLine: false
			};
		},
		computed: {
			...mapGetters('purchaseOrderLines', ['purchaseOrderLines']),
      ...mapState('serviceOrders', ['serviceordersList']),
			...mapState('salesReps', ['salesReps']),
			/*...mapState('purchaseorders', [
				'purchaseorders',
			]),*/
			...mapGetters('purchaseorders', [
				'purchaseorder',
				'gridList',
				'pageInfo',
				'filters',
				'filtersReceive',
        'lastOpenedId','tblLoader'
			]),
      ...mapGetters('serviceOrderLines', ['serviceOrderLineByPoLine']),
			...mapGetters('account', ['gridSettingsById']),
			filtersObj() {
				if(this.isReceive) { // Purchase Order Receive
					return this.filtersReceive;
				} else {
					return this.filters[this.filterPageName] || {}
				}
			},
			gridSettings() {
				return this.gridSettingsById(this.gridId);
			},
			itemData() {
        if (this.gridList == undefined || !this.gridList.length) return [];
				return this.gridList.map((purchaseorder) => ({ ...purchaseorder, selected: purchaseorder.id === this.selectedRowItemId }));
			},
			isDisableReceiveItem() {
				return Object.keys(this.purchaseOrderLine).length == 0;
			}
		},
		methods: {
			...mapMutations('purchaseorders', ['setSelectedItemId','setItem']),
			//...mapMutations('salesOrderLines', [ 'clearSalesOrderLinesByCompany' ]),
			...mapActions('purchaseorders', [
				'getAll',
				'getAllOpenPurchaseOrders',
				'sortGrid',
				'getPage',
				'search',
				'searchReceive',
				//'select',
				'deletePurchaseOrder'
			]),
			...mapActions('purchaseOrderLines', ['updatePurchaseOrderLine']),
			...mapActions('account', ['saveGridSettings']),
			...mapActions('salesReps', ['getSalesReps']),

        async onGetData(params) {
            if(this.isReceive) { // Purchase Order Receive
                await this.getAllOpenPurchaseOrders(params);
            } else {
                await this.getAll(params);
            }
        },
        onSearch: debounce(function(data = false) {
            if(typeof data === 'object') { Object.assign(this.filtersObj,data) }
            if(this.isReceive) { // Purchase Order Receive
                this.searchReceive(this.filtersObj);
            } else {
                this.search({'filters':this.filtersObj,page:this.filterPageName});
            }
        }, SEARCH_DEBOUNCE_TIME),
        clearFilter(callSearch = true) {
            this.clearObject(this.filtersObj);
            if(this.isReceive && callSearch) { // Purchase Order Receive
                this.searchReceive(this.filtersObj);
            } else if(callSearch){this.search({'filters':this.filtersObj,page:this.filterPageName});}
        },
		/*	clearFilter(callSearch=true) {
				//this.clearFilters;
				Object.keys(this.filtersObj).forEach(filterName => {
					this.filtersObj[filterName] = null;
				});

				this.$refs.dateRangePicker.setDateRangeAll(); //Clear date range picker

				if(this.isReceive && callSearch) { // Purchase Order Receive
					this.searchReceive(this.filtersObj);
				} else if(callSearch){this.search({'filters':this.filtersObj,page:this.filterPageName});}
			},*/
		/*	async onGetData(params) {
				if(this.isReceive) { // Purchase Order Receive
					await this.getAllOpenPurchaseOrders(params);
				} else {
					await this.getAll(params);
				}

				this.skip = params.pageSize * (params.pageNumber - 1);
				this.take = params.pageSize;
			},*/
			async onDelete({ id }) {
				this.selectedRowItemId = id;
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete purchase order?  This action cannot be undone`});
        if (deleteConfirmed) {
          const response = await this.deletePurchaseOrder(id);
					if (response != undefined && response.status == 200) {		
						this.selectedRowItemId = (this.selectedRowItemId == id) ? 0 : this.selectedRowItemId;
						this.getAll({});
					}
        }
			},
			onRowClick(row) {
				this.selectedRowItemId = row.dataItem.id;
				this.setItem({ resource: 'lastOpenedId', payload: row.dataItem.id });
				this.purchaseOrderLine = {};
				// const { id, detailsVisible } = row.dataItem;
				// this.select({ id, isChecked: !detailsVisible });
			},
			onEdit(row) {
				this.setItem({ resource: 'lastOpenedId', payload: row.id });
				this.$router.push({
					name: 'purchaseorders.edit',
					params: { id: row.id },
				});
			},
			onShowEdit(purchaseOrderLine) {
				this.purchaseOrderLine = purchaseOrderLine;
				this.purchaseOrderLinePartForm = purchaseOrderLine;

				this.$refs['add-part-popup'].show();
			},
			purchaseOrderLineSelected(orderLine) {
				this.purchaseOrderLine = orderLine;
			},
			onPartChange(partObj) {
				this.mergedObj = {
					...this.mergedObj,
					...partObj
				};
			},
			onLineChange(lineObj) {
				this.mergedObj = {
					...this.mergedObj,
					...lineObj
				};
			},
			onHeaderChange(headerObj) {
				this.mergedObj = {
					...this.mergedObj,
					...headerObj
				};
			},
			async savePartForm(bvModalEvt) {
				await this.$refs.editLineDetails.getLineValidation();
				if(!this.isLineInvalid) {
					if (this.purchaseOrderLine.qtyReceived > this.mergedObj.quantity) {
						this.openAlertBox({message: `Invalid Update. Quantity inputted is lesser than the received quantity`});
					} else if (this.purchaseOrderLine.qtyAllocated > this.mergedObj.quantity) {
						this.openAlertBox({message: `Invalid Update. Quantity inputted is lesser than the allocated quantity`});
					} else {
						this.isSavingLine = true;
						this.mergedObj.id = this.purchaseOrderLine.id;
						this.mergedObj.purchaseOrderId = this.purchaseOrderId;
						this.mergedObj.dateDue = this.purchaseOrderLine.dateDue;

						await this.updatePurchaseOrderLine(this.mergedObj);
						this.isSavingLine = false;
        		this.$bvModal.hide('add-part-popup');
						// await this.getPurchaseOrderLines(this.purchaseOrderId);
					}					
				}
			},
			handleCancel() {

			},
			onReceiveItem() {
				this.$router.push({
					name: 'shipping.receiveitemdetails',
					params: { purchaseOrderId: this.selectedRowItemId,
           				purchaseOrderLineId: this.purchaseOrderLine.id, },
				});
			},
		},
		watch: {
			async gridList() {
				//This function sets the first row as the selected row
        this.selectedRowItemId = await this.setSelectedRowId(this.gridList,this.selectedRowItemId,this.lastOpenedId);
        if(!this.gridList.length){
            this.purchaseOrderLineSelected({})
        }
			},
		},
		async mounted() {
        this.setItem({ resource:'filterPage', payload: this.filterPageName });

        if('statisticFilter' in this.$route.params && this.$route.params.statisticFilter){
          this.clearObject(this.filtersObj);
        }

        if('needsAuthorization' in this.$route.params && this.$route.params.needsAuthorization) {
          this.filtersObj.needsAuthorization = true;
          delete this.$route.params.needsAuthorization;
        }

        if('purchaseOrdersStatus' in this.$route.params) {
          this.filtersObj.statusId = this.$route.params.purchaseOrdersStatus;
          delete this.$route.params.purchaseOrdersStatus;
        }

        if(this.isReceive) { // Purchase Order Receive
          if('statisticFilter' in this.$route.params && this.$route.params.statisticFilter) {
            delete this.$route.params.statisticFilter;
            this.searchReceive(this.filtersObj);
          }else {
            await this.getAllOpenPurchaseOrders({});
          }
        } else {
          if('statisticFilter' in this.$route.params && this.$route.params.statisticFilter) {
            this.search({'filters':this.filtersObj,page:this.filterPageName});
            delete this.$route.params.statisticFilter;
          }else {
            this.setItem({
              resource: 'pageInfo',
              payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize}
            });
            await this.getAll({});
          }
        }
        this.getSalesReps();
		},
		beforeDestroy() {
			//this.select({ id: null, isChecked: false });
		},
	};
</script>